import { ContentItem } from '../contentItem/ContentItem';
import { MetricsContent } from '../metric/MetricsContent';
import { NotesContent } from '../notes/NotesContent';
import { useFacade } from './useFacade';

import * as S from './Content.styled';

export const Content = ({ selectedDate, data }) => {
  const { campaignChanges, isChangesError, isNotesError } = useFacade(selectedDate);

  //const testNote = '{"blocks":[{"key":"9q936","text":" еуые ","type":"unstyled","depth":0,"inlineStyleRanges":[],"entityRanges":[],"data":{}}],"entityMap":{}}';

  return (
    <S.PanesContainer>
      <S.Pane>
        <S.PaneTitle>Metrics:</S.PaneTitle>
        <MetricsContent selectedDate={selectedDate} data={data}></MetricsContent>
      </S.Pane>
      <S.Pane>
        <S.PaneTitle>Campaign Updates</S.PaneTitle>
        {campaignChanges.length > 0 &&
          !isChangesError &&
          campaignChanges.map((item, index) => (
            <ContentItem key={index} cm_campaignid={item.cm_campaignid} changes={item.changes} />
          ))}
        {campaignChanges.length === 0 && !isChangesError && (
          <S.Text>No changes for the current filter.</S.Text>
        )}
        {isChangesError && <S.Text>Error: loading failed.</S.Text>}
      </S.Pane>
      <S.Pane>
        <NotesContent
          note={data.note}
          //note={testNote}
          selectedDate={selectedDate}
          isNotesError={isNotesError}
        ></NotesContent>
      </S.Pane>
    </S.PanesContainer>
  );
};

Content.displayName = 'Content';
